import React, { useRef, useState, useEffect } from 'react';
import bell from '../../images/project/bell.png';
import contact from '../../images/project/contact.png';
import clairvoyix from '../../images/project/clairvoyix-image.gif'
import '../../scss/header.scss';
import getCommonResponse from '../actions/Common';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import Tooltip from "@material-ui/core/Tooltip";

function ClickOutside(ref, setShow) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setShow(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}
  
function Header() {
    const wrapperRef = useRef(null);
    const [show, setShow] = useState(false);
    ClickOutside(wrapperRef, setShow);
    const userName = useSelector((state) => state.userName);
    const urllogo = useSelector((state) => state.url);
    console.log("Reduxusername", userName, urllogo);
    const notification = useSelector((state) => state.notification);
    const accesstoken =  Cookies.get('access_token');
    const userRole = useSelector((state) => state.role);

    const navigate = useNavigate();
    function myProfile() {
        setShow(false);
        navigate('/profile')
    }
    function Logout() {
        setShow(false);
        const URL = '/api/users/logout';
        getCommonResponse.GetLogout(URL, accesstoken, (response) => {
           console.log("logoutresponse", response);
           Cookies.remove('access_token');
           Cookies.remove('refresh_token');
           navigate('/');
        });
    }
    function ToNotification() {
        navigate('/notification');
    }
    function usersNavigation() {
        setShow(false);
        navigate('/users/list')
    }
    return (
        <div className='header'>
            <div className='header-left'>
                <img src={clairvoyix}></img>
            </div>
            <div className='header-right' ref={wrapperRef}>
                <Tooltip title="Notifications">
                    <img className='bell' src={bell} alt="bellimage" onClick={ToNotification}></img>
                </Tooltip>
                <div className={`${window.location.href.includes('notification') ? 'dot hide' : notification ? 'dot' : 'dot hide'}`}></div>
                <div className='account' onClick={() => setShow(!show)}>
                    <img className='contact' src={urllogo} alt=""></img>
                    <div className='owner'>{userName && userName}</div>
                </div>
                { show &&
                    <>
                        <div className='profile-logout-container'>
                            <div onClick={myProfile} className='profile options'>My Profile</div>
                            <div className='border-division'></div>
                            {userRole == 1 && 
                            <>
                                <div onClick={usersNavigation} className='profile options'>C3 Users</div>
                                <div className='border-division'></div>
                            </>}
                            <div className='logout options' onClick={Logout}>Logout</div>
                        </div>
                        <div className='profile-logout-arrow'>
                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default Header;